import { Redirect, Route, Switch } from "react-router-dom";
import React from "react";
import { loginStore } from "@/modules/login/store";
// import loadable from "@loadable/component";
import Login from "@/pages/Login";
import NoPermission from "@/pages/NoPermission";
import Editor from "@/pages/Editor";
import Gallery from "@/pages/Gallery";
import MySpace from "@/pages/Space/MySpace";
import Business from "@/pages/Business";
import OthersSpace from "@/pages/Space/OthersSpace";
import Setting from "@/pages/Setting";
import Order from "@/pages/Order";
import Arts from "@/pages/Gallery/arts";
import Test from "@/pages/Test";
import NotFound from "@/pages/NotFound";
// import { MattEditorPage } from "@/pages/MattEditor";
// import { PageLoad } from "@/components/NoliLoading/PageLoading";
// const Editor = loadable(() => import(/* webpackPrefetch: true */ "@/pages/Editor"), {
//   fallback: <PageLoad />,
// });
// const Gallery = loadable(() => import(/* webpackPrefetch: true */ "@/pages/Gallery"), {
//   fallback: <PageLoad />,
// });
// const MySpace = loadable(() => import(/* webpackPrefetch: true */ "@/pages/Space/MySpace"), {
//   fallback: <PageLoad />,
// });
// const NotFound = loadable(() => import("@/pages/NotFound"), { fallback: <PageLoad /> });
// const Test = loadable(() => import("@/pages/Test"), { fallback: <PageLoad /> });
// const Arts = loadable(() => import(/* webpackPrefetch: true */ "@/pages/Gallery/arts"), {
//   fallback: <PageLoad />,
// });
// const Order = loadable(() => import("@/pages/Order"), { fallback: <PageLoad /> });
// const Setting = loadable(() => import("@/pages/Setting"), { fallback: <PageLoad /> });
// const OthersSpace = loadable(() => import("@/pages/Space/OthersSpace"), { fallback: <PageLoad /> });
// const Business = loadable(() => import("@/pages/Business"), { fallback: <PageLoad /> });
// const NoPermission = loadable(() => import("@/pages/NoPermission"), { fallback: <PageLoad /> });
// const Login = loadable(() => import("@/pages/Login"), { fallback: <PageLoad /> });

export default (
  <Switch>
    <Route
      path="/creator"
      exact
      render={(props) => {
        if (loginStore.hasAIGCPermission) {
          return <Editor />;
        }
        return <Redirect to="/" />;
      }}
    />
    <Route
      path="/"
      exact
      render={(props) => {
        return <Login {...props} />;
      }}
    />
    <Route
      path="/login"
      exact
      render={(props) => {
        return <Login {...props} />;
      }}
    />

    <Route
      exact
      path="/guest"
      render={() => {
        loginStore.setGuest(true);
        return <Editor />;
      }}
    />
    <Route
      exact
      path="/noPermission"
      render={() => {
        if (loginStore.isLogin) return <NoPermission />;
        return <Redirect to="/" />;
      }}
    ></Route>
    <Route exact path="/gallery" component={Gallery} key="/gallery"></Route>
    <Route exact path="/my_space" component={MySpace}></Route>
    <Route exact path="/business" component={Business}></Route>
    <Route exact path="/artists/:userId" component={OthersSpace} key="/artists"></Route>
    <Route
      exact
      path="/setting"
      render={() => {
        if (loginStore.isLogin) return <Setting />;
        return <Redirect to="/" />;
      }}
    ></Route>
    <Route
      exact
      path="/order"
      render={() => {
        if (loginStore.isLogin) return <Order />;
        return <Redirect to="/" />;
      }}
    ></Route>
    <Route exact path="/arts/:id" component={Arts} key="/arts"></Route>
    {/* <Route exact path="/matt" component={MattEditorPage} key="/matt"></Route> */}

    {process.env.REACT_APP_ENV !== "production" ? <Route path="/test" component={Test} /> : null}
    <Route path="/404" component={NotFound} />
  </Switch>
);
